import { Box, useLayoutContext } from "arkh";
import { PILL_INDICATOR_SIZE } from "../PillIndicator";

export function WorkspaceTodoItemRowContainer(props: {
  priority: React.ReactNode;
  description: React.ReactNode;
  published: React.ReactNode;
  deadline: React.ReactNode;
  status: React.ReactNode;
  more: React.ReactNode;
  topic?: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      <WorkspaceTodoPrioColumnContainer>
        {props.priority}
      </WorkspaceTodoPrioColumnContainer>
      <Box
        style={{
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Box
          style={{ width: props.topic ? "40%" : "50%", minWidth: 150 }}
          spaceRight="medium"
        >
          {props.description}
        </Box>
        <Box
          style={{ width: props.topic ? "20%" : "30%", minWidth: 100 }}
          spaceRight="small"
        >
          {props.published}
        </Box>
        <Box
          style={{
            width: "20%",
            minWidth: 100,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {props.deadline}
        </Box>
        {props.topic ? (
          <Box
            spaceRight="small"
            style={{
              width: "20%",
              minWidth: 100,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {props.topic}
          </Box>
        ) : null}
      </Box>

      <WorkspaceTodoStatusColumnContainer>
        {props.status}
      </WorkspaceTodoStatusColumnContainer>
      <Box style={{ width: 20 }}>{props.more}</Box>
    </Box>
  );
}

export function WorkspaceTodoPrioColumnContainer(props: {
  children: React.ReactNode;
}) {
  return <Box style={{ width: 50 }}>{props.children}</Box>;
}

export function WorkspaceTodoStatusColumnContainer(props: {
  children: React.ReactNode;
}) {
  const layout = useLayoutContext();
  return (
    <Box
      style={{
        width: PILL_INDICATOR_SIZE.width + layout.space.medium,
        alignItems: "flex-end",
      }}
    >
      {props.children}
    </Box>
  );
}
